import { useEffect } from 'react';

// Global hotkey: Ctrl+A then Ctrl+D (Windows/Linux) or Cmd+A then Cmd+D (Mac).
// Both keystrokes must happen within 1.5s while a modifier is held, and the
// user must not be typing in an input/textarea. Also fires if all three keys
// happen to be held down at once — supports both press styles.
const WINDOW_MS = 1500;

const isEditable = (el) => {
  if (!el) return false;
  const tag = el.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  return !!el.isContentEditable;
};

export const useAdminHotkey = (onTrigger) => {
  useEffect(() => {
    let sawA = 0; // timestamp of last valid Ctrl/Cmd+A
    const heldA = { v: false };

    const onDown = (e) => {
      if (isEditable(e.target)) return;
      const key = (e.key || '').toLowerCase();
      const mod = e.ctrlKey || e.metaKey;
      if (!mod) return;
      if (key === 'a') {
        // Suppress native "select all" on the page (we're outside inputs).
        e.preventDefault();
        sawA = Date.now();
        heldA.v = true;
        return;
      }
      if (key === 'd') {
        const withinWindow = Date.now() - sawA <= WINDOW_MS;
        if (withinWindow || heldA.v) {
          e.preventDefault();
          sawA = 0;
          heldA.v = false;
          onTrigger();
        }
      }
    };
    const onUp = (e) => {
      if ((e.key || '').toLowerCase() === 'a') heldA.v = false;
    };
    const clear = () => { sawA = 0; heldA.v = false; };
    window.addEventListener('keydown', onDown, true);
    window.addEventListener('keyup', onUp, true);
    window.addEventListener('blur', clear);
    return () => {
      window.removeEventListener('keydown', onDown, true);
      window.removeEventListener('keyup', onUp, true);
      window.removeEventListener('blur', clear);
    };
  }, [onTrigger]);
};
